import { render, staticRenderFns } from "./TsysCard.vue?vue&type=template&id=91fa5906&scoped=true&"
import script from "./TsysCard.vue?vue&type=script&lang=js&"
export * from "./TsysCard.vue?vue&type=script&lang=js&"
import style0 from "./TsysCard.vue?vue&type=style&index=0&id=91fa5906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa5906",
  null
  
)

export default component.exports